import React from 'react';
import { Helmet } from 'react-helmet-async';

import { Config } from '@nw/shared/config';

export interface SeoDetails {
  title: string;
  description: string;
  path?: string;
}

export const SeoTags = ({ seoInfo }: { seoInfo: SeoDetails }): JSX.Element => {
  const { title, description, path } = seoInfo;
  const baseUrl = Config['PORTAL_BASE_URL'];
  const ogUrl = path ? `${baseUrl}${path}` : baseUrl;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={ogUrl} />
    </Helmet>
  );
};
